

import { AnswerRepository } from './AnswerRepository';
import {DailyPerformanceRecord } from '@PikaDoApp/npm-pikado-logic';

import { AnswerMergedResponse } from './AnswerTypes';

export class AnswerService{
  answerRepository: AnswerRepository;

  constructor() {
    this.answerRepository = new AnswerRepository();
  }

  async getAnswer(id: string): Promise<AnswerMergedResponse> {
    return await this.answerRepository.getAnswer(id);
  }
    async getDailyPerformanceById(id: string): Promise<DailyPerformanceRecord> {
    return await this.answerRepository.getDailyPerformanceById(id);
  }
}
